import Cricket from '../assets/sports/cricket.svg';
import Football from '../assets/sports/soccer.svg';
import Tennis from '../assets/sports/tennis.svg';
import Kabaddi from '../assets/sports/kabaddi.svg';
import BasketBall from '../assets/sports/basketball.svg';
import BaseBall from '../assets/sports/baseball.svg';
import GreyHound from '../assets/sports/greyhound.svg';
import HorseRace from '../assets/sports/horserace.svg';
import VolleyBall from '../assets/sports/volleyball.svg';
import Darts from '../assets/sports/darts.svg';
import Futsal from '../assets/sports/futsal.svg';
import TableTennis from '../assets/sports/tabletennis.svg';
import Binary from '../assets/sports/binary.svg';
import Politics from '../assets/sports/politics.svg';
import IceHockey from '../assets/sports/icehockey.svg';
import MMA from '../assets/sports/mma.svg';
import Rugby from '../assets/sports/rugby.svg';
import SBSoccer from '../assets/sbsports/soccer.svg';
import SBTennis from '../assets/sbsports/tennis.svg';
import SBCricket from '../assets/sbsports/cricket.svg';
import SBBadminton from '../assets/sbsports/badminton.svg';
import SBBasketball from '../assets/sbsports/basketball.svg';
import SBBaseball from '../assets/sbsports/baseball.svg';
import SBTableTennis from '../assets/sbsports/tabletennis.svg';
import SBKabaddi from '../assets/sbsports/kabaddi.svg';
import SBMMA from '../assets/sbsports/mma.svg';
import SBIceHockey from '../assets/sbsports/icehockey.svg';
import SBVolleyball from '../assets/sbsports/volleybal.svg';
import SBSquash from '../assets/sbsports/squash.svg';
import SBSnooker from '../assets/sbsports/snooker.svg';
import SBFutsal from '../assets/sbsports/futsal.svg';
import SBAmericanFootball from '../assets/sbsports/americanfootball.svg';
import SBRugby from '../assets/sbsports/rugby.svg';
import SBDarts from '../assets/sbsports/darts.svg';
import SBHorseRacing from '../assets/sbsports/horserace.svg';
import SBGreyhound from '../assets/sbsports/greyhound.svg';

export const sportsIconMap: Record<string, string> = {
    "4": Cricket,
    "1": Football,
    "2": Tennis,
    "27979456": Kabaddi,
    '7522': BasketBall,
    '7511': BaseBall,
    '4339': GreyHound,
    '7': HorseRace,
    '99990': Binary,
    '2378961': Politics,
    '26420387': MMA,
    '998917': VolleyBall
};

export const sportNamesMap: Record<string, string> = {
    "4": "CRICKET",
    "1": "FOOTBALL",
    "2": "TENNIS",
    "LIVE": "LIVE",
    "UPCOMING": "UPCOMING",
    "27979456": "KABADDI",
    '7522': "BASKETBALL",
    '7511': "BASEBALL",
    '4339': "GREYHOUND",
    '7': "HORSE RACE",
    '99990': "BINARY",
    '2378961': "POLITICS",
    '26420387': "MMA",
    '998917': "VOLLEYBALL"
};

export const sbsportsIconMap: Record<string, string> = {
    "sr:sport:1": SBSoccer,
    "sr:sport:5": SBTennis,
    "sr:sport:21": SBCricket,
    "sr:sport:31": SBBadminton,
    "sr:sport:2": SBBasketball,
    "sr:sport:3": SBBaseball,
    "sr:sport:20": SBTableTennis,
    "sr:sport:138": SBKabaddi,
    "sr:sport:117": SBMMA,
    "sr:sport:4": SBIceHockey,
    "sr:sport:23": SBVolleyball,
    "sr:sport:37": SBSquash,
    "sr:sport:19": SBSnooker,
    "sr:sport:29": SBFutsal,
    "sr:sport:16": SBAmericanFootball,
    "sr:sport:12": SBRugby,
    "sr:sport:22": SBDarts,
    "sr:sport:55": SBHorseRacing,
    "sr:sport:58": SBGreyhound,
};

export const srsportNamesMap: Record<string, string> = {
    "sr:sport:1": "Soccer",
    "sr:sport:5": "Tennis",
    "sr:sport:21": "Cricket",
    "sr:sport:31": "Badminton",
    "sr:sport:2": "Basketball",
    "sr:sport:3": "Baseball",
    "sr:sport:20": "Table Tennis",
    "sr:sport:138": "Kabaddi",
    "sr:sport:117": "MMA",
    "sr:sport:4": "Ice Hockey",
    "sr:sport:23": "Volleyball",
    "sr:sport:37": "Squash",
    "sr:sport:19": "Snooker",
    "sr:sport:29": "Futsal",
    "sr:sport:16": "American Football",
    "sr:sport:12": "Rugby",
    "sr:sport:22": "Darts",
    "sr:sport:55": "Horse racing",
    "sr:sport:58": "Greyhound",
    "LIVE": "Live",
    "UPCOMING": "Upcoming",
};